export const getAuthorUserNameStyle = (theme) => ({
    fontWeight: '900',
});

export const getAuthorFlexStyle = (theme) => ({
    display: 'flex',
});
